import { useEffect } from 'react';

/** Keep trying to open a direct link to the bootstrap peer from invite URLs. */
export default function useBootstrapPeerConnection(node, bootstrapPeer) {
  useEffect(() => {
    if (!node || !bootstrapPeer) {
      return undefined;
    }

    let cancelled = false;

    const connect = () => {
      if (cancelled) {
        return;
      }
      node.ensureConnectedToPeers([bootstrapPeer]).catch(() => undefined);
    };

    connect();
    const timer = setInterval(connect, 4000);

    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [node, bootstrapPeer]);
}
